<template>
  <div>
    <v-card
      :class="$style.modelrepair_widget"
      :style="{'cursor': is_analytics_page ? 'pointer' : 'default'}"
      :loading="result_service_activity_loading"
    >
      <div :class="$style.widget_title">
        <span class="text-h2">Результат сервисной деятельности</span>
      </div>
      <div :class="$style.widget_subtitle">
        за прошедший квартал
      </div>

      <template v-if="is_filters">
        <div class="d-flex mb-6">
          <v-row>
            <v-col
              cols="12"
              xl="4"
              lg="6"
              md="12"
              sm="6"
              xs="12"
            >
              <Select
                :value="filters.rsa_organization_id"
                :items="orgs"
                :class="[$style.select, $style.filterField]"
                label="Организация"
                item-text="name_organization"
                item_value="id"
                multiple
                dense
                hide-details
                clearable
                blue_icon
                @input="filter_update('rsa_organization_id', $event, 'result_service_activity')"
              />
            </v-col>
            <v-col
              cols="12"
              xl="4"
              lg="6"
              md="12"
              sm="6"
              xs="12"
            >
              <Select
                :value="filters.quarter"
                :items="quarter"
                :class="[$style.select, $style.filterField]"
                label="Квартал"
                dense
                hide-details
                clearable
                blue_icon
                @input="filter_update('quarter', $event, 'result_service_activity')"
              />
            </v-col>
            <v-col
              cols="12"
              xl="4"
              lg="6"
              md="12"
              sm="6"
              xs="12"
            >
              <Select
                :value="filters.year"
                :items="years"
                :class="[$style.select, $style.filterField]"
                label="Год"
                dense
                hide-details
                clearable
                blue_icon
                @input="filter_update('year', $event, 'result_service_activity')"
              />
            </v-col>
          </v-row>
        </div>
      </template>

      <div class="text-h3 mb-5">
        {{ service_activity.company }}
      </div>
      <v-row :class="$style.table_head">
        <v-col lg="6">Критерии оценки</v-col>
        <v-col
          class="text-end"
          lg="2"
        >
          Значение
        </v-col>
        <v-col
          class="text-end"
          lg="2"
        >
          Балл
        </v-col>
        <v-col
          class="text-end"
          lg="2"
        >
          Грейд
        </v-col>
      </v-row>
      <template v-if="is_filters">
        <div
          v-for="(item, idx) in analytics_service_activity.items"
          :key="idx"
        >
          <div
            :class="[
              $style.row,
              idx % 2 == 0 ? $style.row_accent : ''
            ]"
          >
            <div :class="$style.name">{{ item.name }}</div>
            <div
              class="text-end"
              :class="$style.value"
            >{{ item.value }}</div>
            <div
              class="text-end font-weight-bold"
              :class="$style.point"
            >
              {{ item.point }}
            </div>
            <div
              class="text-end font-weight-bold"
              :class="$style.grade"
            />
          </div>
        </div>
        <div :class="[$style.row, $style.row_accent]">
          <div
            :class="$style.name"
            class="font-weight-bold"
          >{{ analytics_service_activity.final_score ? analytics_service_activity.final_score.name : '' }}</div>
          <div
            :class="$style.value"
            class="text-end"
          />
          <div
            :class="$style.point"
            class="text-end font-weight-bold"
          >
            {{ analytics_service_activity.final_score ? analytics_service_activity.final_score.value : '' }}
          </div>
          <div
            :class="$style.point"
            class="text-end font-weight-bold"
          >
            {{ analytics_service_activity.final_score ? analytics_service_activity.final_score.grade : '' }}
          </div>
        </div>
      </template>
      <template v-else>
        <div v-if="service_activity_widgets && service_activity_widgets.items">
          <div
            v-for="(item, idx) in service_activity_widgets.items"
            :key="idx"
          >
            <div
              :class="[
                $style.row,
                idx % 2 == 0 ? $style.row_accent : ''
              ]"
            >
              <div :class="$style.name">{{ item.name }}</div>
              <div
                class="text-end"
                :class="$style.value"
              >{{ item.value }}</div>
              <div
                class="text-end font-weight-bold"
                :class="$style.point"
              >
                {{ item.point }}
              </div>
              <div
                class="text-end font-weight-bold"
                :class="$style.grade"
              />
            </div>
          </div>
          <div :class="[$style.row, $style.row_accent]">
            <div
              :class="$style.name"
              class="font-weight-bold"
            >{{ service_activity_widgets.final_score.name }}</div>
            <div
              :class="$style.value"
              class="text-end"
            />
            <div
              :class="$style.point"
              class="text-end font-weight-bold"
            >
              {{ service_activity_widgets.final_score.value }}
            </div>
            <div
              :class="$style.point"
              class="text-end font-weight-bold"
            >
              {{ service_activity_widgets.final_score.grade }}
            </div>
          </div>
        </div>
      </template>
    </v-card>
  </div>
</template>

<script lang="ts">
import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import { widgets_store, analytics_store } from '@/store';
import { Select } from '@/components/global';
import { plan_quarter } from '@/enums';
import { Analytics, AnalyticsFilters } from '@/modules/analytics/types';
import { current_year, current_quarter } from '@/utils';

const { state } = widgets_store;

const analytics_state = analytics_store.state;

@Component({
  components: {
    Select,
  },
})
export default class WidgetModelsReports extends Vue {
  @Prop({ type: Boolean, default: false })
  is_filters!: boolean;

  mounted() {
    this.first_request();
  }

  @Emit()
  filter_update(key: keyof AnalyticsFilters, value: unknown, section: string) {
    analytics_store.mutations.UPD_FILTER_KEY({ key, value, section });
  }

  @Emit()
  first_request() {
    analytics_store.mutations.UPD_FILTER_KEY({ key: 'quarter', value: (current_quarter() - 1), section: 'result_service_activity' });
    analytics_store.mutations.UPD_FILTER_KEY({ key: 'year', value: String(current_year()), section: 'result_service_activity' });
  }

  quarter = plan_quarter;

  get result_service_activity_loading() {
    return analytics_state.result_service_activity_loading;
  }

  get service_activity() {
    return analytics_state.analytics.result_service_activity;
  }

  get service_activity_widgets() {
    return state.widgets.result_service_activity;
  }

  get analytics_service_activity() {
    const response_filters = this.has_response_filters();

    return response_filters
      ? analytics_state.response_filters.result_service_activity
      : analytics_state.analytics.result_service_activity;
  }

  get orgs() {
    return analytics_state.organizations;
  }

  get filters() {
    return analytics_state.filters;
  }

  get years() {
    return analytics_state.years;
  }

  get is_analytics_page() {
    return this.$route.name !== Analytics.Pages.ANALYTICS;
  }

  has_response_filters() {
    return (
      analytics_state.filters.quarter !== null
      || analytics_state.filters.rsa_organization_id.length > 0
      || analytics_state.filters.year !== null
    );
  }
}
</script>

<style module lang="scss">
@import '@/scss/common/filter-blocks.scss';

.modelrepair_widget {
  border: solid 1px black;
  // height: 588px;
  display: flex;
  flex-direction: column;
  padding: 24px;
}
.widget_title {
  font-style: 24px;
  font-weight: 600;
  line-height: 32px;
  color: #13141C;
}

.widget_subtitle {
  font-size: 18px;
  line-height: 24px;
  color: #696C86;
  margin-bottom: 24px;
}

.row {
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 8px;
}

.table_head {
  font-size: 11px;
  text-transform: uppercase;
  padding: 8px 16px;
}

.row_accent {
  background-color: #F6F7FA;
}

.name {
  flex: 0 0 50%;
}
.value {
  flex: 0 0 16.6666%;
}
.point {
  flex: 0 0 16.6666%;
}
.grade {
  flex: 0 0 16.6666%;
}

.filterField {
  max-width: 100% !important;
}
</style>
